import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import { ReactComponent as Logo } from "../../img/ic4-logo.svg";
import { clearPortalAuth } from "../../lib/authStorage";
import CaProfile from "../../models/domain/CaProfile";

interface Props {
  profile: CaProfile;
  onContactClick?: () => void;
}

export default function CaHeader({ profile, onContactClick }: Props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const logout = () => {
    clearPortalAuth();
    setAnchorEl(null);
    navigate("/");
  };

  return (
    <header className="ca-portal-header">
      <div className="ca-portal-header__inner">
        <div className="ca-portal-header__logo">
          <Logo />
        </div>
        <h1 className="ca-portal-header__title">Form 25 Register</h1>
        <div className="ca-portal-header__actions">
          <button
            type="button"
            className="ca-portal-header__contact-btn"
            onClick={onContactClick}
          >
            <MailOutlineIcon fontSize="small" />
            Contact Us
          </button>
          <button
            type="button"
            className="ca-portal-header__profile"
            onClick={(e) => setAnchorEl(e.currentTarget)}
            aria-haspopup="true"
          >
            <span>{profile.name}</span>
            <span className="ca-portal-header__avatar">
              <PersonOutlineIcon fontSize="small" />
            </span>
          </button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </div>
      </div>
    </header>
  );
}
